import api from './api';

export interface AnimationContainer {
  id: number;
  title: string;
  description: string;
  parent: number | null;
  created_by: number;
  created_at: string;
  updated_at: string;
  order: number;
  children_count: number;
  animations_count: number;
}

class AnimationContainerService {
  async getContainers(parentId: number | null = null): Promise<AnimationContainer[]> {
    const params = parentId === null ? { parent: 'null' } : { parent: parentId };
    const response = await api.get('/animation-containers/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainer(id: number): Promise<AnimationContainer> {
    const response = await api.get(`/animation-containers/${id}/`);
    return response.data;
  }

  async getContainerContents(id: number): Promise<{ containers: AnimationContainer[], animations: any[] }> {
    const response = await api.get(`/animation-containers/${id}/contents/`);
    return response.data;
  }

  async createContainer(data: Partial<AnimationContainer>): Promise<AnimationContainer> {
    const response = await api.post('/animation-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<AnimationContainer>): Promise<AnimationContainer> {
    const response = await api.patch(`/animation-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/animation-containers/${id}/`);
  }

  async reorderContainers(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/animation-containers/reorder/', { items });
  }
}

const animationContainerService = new AnimationContainerService();
export default animationContainerService;
